<template>
    <rkm-modal
        :buttons="['cancel']"
        :loading="loading"
        large
        ref="Modal"
        title="Detalhes"
    >
        <rkm-table
            :fields="fields"
            :items="items"
            hide-filters
            hide-pagination
            thead-class="d-none"
        />
    </rkm-modal>
</template>

<script>
// Vuex.
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        fields() {

            return [
                {
                    key: "field",
                    class: "font-weight-bold col-min",
                },
                {
                    key: "value",
                },
            ]
        }
    },
    data: () => ({
        items: [],
    }),
    methods: {
        open(item) {

            this.items = [
                {
                    field: 'Unidade solicitante',
                    value: item.unidadeSolicitanteNomeFantasia,
                },
                {
                    field: 'Local de atendimento solicitante',
                    value: item.infraestruturaSolicitanteNome,
                },
                {
                    field: 'Profissional solicitante',
                    value: item.usuarioSolicitanteNome,
                },
                {
                    field: 'HD',
                    value: item.hipoteseDiagnosticaJustificativa,
                },
                {
                    field: 'Agendamento',
                    value: item.agendamento,
                },
                {
                    field: 'Usuário que registrou a solicitação',
                    value: item.usuarioRegistrouSolicitacaoNome,
                },
            ]

            this.$refs.Modal.show()
        },
    }
}
</script>